/* ============================================================
   EDENVALE - GREECE MARKET LANDING PAGE
   Page interactions: language switch and reveal-on-scroll.

   The product grids are Shopify section blocks now, not JS-rendered
   data, so the product array from the staging build is gone. Copy is
   edited in the theme editor instead.
   ============================================================ */
(function () {
  'use strict';

  var page = document.querySelector('.gr-page');
  if (!page) return;

  /* ---------- 1. Language switch ----------
     Defaults to English so the page reviews cleanly on the AU site.
     Greek-language browsers land on Greek automatically, and an explicit
     choice is remembered for return visits. */
  var KEY = 'edenvale-gr-lang';

  function buttons() {
    return document.querySelectorAll('[data-set-lang]');
  }

  function apply(lang, persist) {
    page.dataset.lang = lang;
    document.documentElement.lang = lang === 'el' ? 'el' : 'en';
    buttons().forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.setLang === lang));
    });
    if (persist) {
      try { localStorage.setItem(KEY, lang); } catch (e) { /* storage unavailable */ }
    }
  }

  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) { /* storage unavailable */ }

  var browserIsGreek = (navigator.languages || [navigator.language || ''])
    .some(function (l) { return String(l).toLowerCase().indexOf('el') === 0; });

  apply(saved || (browserIsGreek ? 'el' : 'en'), false);

  /* Delegated, so the switch keeps working after the theme editor re-renders
     the header section. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-set-lang]') : null;
    if (!btn) return;
    apply(btn.dataset.setLang, true);
  });

  /* ---------- 2. Reveal on scroll ---------- */
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.gr-page .reveal').forEach(function (el) { el.classList.add('in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function observe() {
    document.querySelectorAll('.gr-page .reveal:not(.in)').forEach(function (el, i) {
      el.style.transitionDelay = (i % 3) * 80 + 'ms';
      io.observe(el);
    });
  }

  observe();

  /* Re-observe after a section is re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', observe);
})();
